import $ from "jquery-import";
import { fix_register } from "coronis";
import coronis from "coronis";
import jsfix from "jsfix";
import _ from "trans";
import coronis from "coronis";
import utils from "utils";
import "jquery-ui-import";
import { import_by_name } from "imports";
import initDatepickerDefaults from "../../../healthmotiv/base/js/datepicker-init";

var d = {};
d.fixDateInputs = function (root) {
  if (root.find("[datepicker],.date").length > 0) {
    utils.requireCSS("../js/main");
    // console.log("fixDateInputs", root);
    try {
      initDatepickerDefaults({ lang: _.languageCode });
    } catch (e) {
      console.error("could not set datepicker defaults", e);
    }

    $(root.find("[datepicker],.date").not(".hasDatepicker,.template")).each(
      function () {
        var dp = $(this);
        var opts = {};
        if (dp.attr("method") == "future") opts.minDate = 0;
        dp.datepicker(opts);
      }
    );
  }
};

// d.fixAutocomplete = function (root) {
//   if (root.find("[autocomplete]").not("[autocomplete=off]").length > 0) {
//     $(root.find("[autocomplete]").not("[autocomplete=off]")).each(function () {
//       const $el = $(this);
//       var source = window[$el.attr("autocomplete")];
//       // 					console.log(this)
//       if (!source) {
//         var url = $(this).attr("autocomplete");
//         var depends = $(this).attr("depends");
//         if (depends) {
//           source = function (request, response) {
//             var data = { term: request.term };
//             data[depends] = $("#" + depends).val();
//             $.get(
//               url,
//               data,
//               function (res) {
//                 response(res);
//               },
//               "json"
//             );
//           };
//         } else source = url;
//       }
//       // 					console.log(source)
//       $el
//         .autocomplete({
//           source: source,
//           minLength: 0,
//           close: window[$el.attr("onchange")],
//         })
//         .attr("autocomplete", "off");
//       if ($el.hasClass("autopop")) {
//         $el.bind("focus", function () {
//           $el.autocomplete("search");
//         });
//       }
//     });
//   }
// };

d.fixTimeInputs = function (root) {
  $(root.find("input.time")).each(function () {
    const $el = $(this);
    var sel = $("<select>");
    var attrs = ["id", "name", "class"];
    for (var i in attrs) {
      var a = attrs[i];
      sel.attr(a, $el.attr(a));
    }

    var zero_pad_2 = function (n) {
      var nn = "0" + n;
      nn = nn.substr(nn.length - 2);
      return nn;
    };
    var time_to_min = function (hhmm) {
      var HM = v.split(":");
      var HH, MM;
      if (HM[0][0] == "0") HH = Number(HM[0][1]);
      else HH = Number(HM[0]);
      if (HM[1][0] == "0") MM = Number(HM[1][1]);
      else MM = Number(HM[1]);
      return HH * 60 + MM;
    };
    var min_to_time = function (vmin) {
      return zero_pad_2(Math.floor(vmin / 60)) + ":" + zero_pad_2(vmin % 60);
    };

    for (var h = 0; h < 24; h++) {
      var hh = zero_pad_2(h);
      for (var m = 0; m < 60; m += 15) {
        var mm = zero_pad_2(m);
        var hhmm = hh + ":" + mm;
        sel.append($("<option>").val(hhmm).text(hhmm));
      }
    }
    var v = $el.val() || "09:00";
    var vmin = time_to_min(v);
    vmin = Math.round(vmin / 15) * 15;
    v = min_to_time(vmin);
    $el.replaceWith(sel);

    sel.val(v);
  });
};

d.fixRequired = function (root) {
  if (root.find(".required").length) {
    // dynamic load validate only when needed.
    import_by_name("jquery-validation").then(function () {
      root
        .find("form")
        .has(".required")
        .each(function () {
          const $el = $(this);
          console.log("validate", $el);

          const rules = $el.find(".required").map(function () {
            return {
              [$(this).attr("name")]: {
                required: true,
              },
            };
          });
          $el.validate({
            rules,
          });
        });

      // validator translations from http://ajax.aspnetcdn.com/ajax/jquery.validate/1.9/localization/messages_fr.js
      if (_.languageCode == "es") {
        /*
         * Translated default messages for the jQuery validation plugin.
         * Locale: ES
         */
        jQuery.extend(jQuery.validator.messages, {
          required: "Este campo es obligatorio.",
          remote: "Por favor, rellena este campo.",
          email: "Por favor, escribe una dirección de correo válida",
          url: "Por favor, escribe una URL válida.",
          date: "Por favor, escribe una fecha válida.",
          dateISO: "Por favor, escribe una fecha (ISO) válida.",
          number: "Por favor, escribe un número entero válido.",
          digits: "Por favor, escribe sólo dígitos.",
          creditcard: "Por favor, escribe un número de tarjeta válido.",
          equalTo: "Por favor, escribe el mismo valor de nuevo.",
          accept: "Por favor, escribe un valor con una extensión aceptada.",
          maxlength: jQuery.validator.format(
            "Por favor, no escribas más de {0} caracteres."
          ),
          minlength: jQuery.validator.format(
            "Por favor, no escribas menos de {0} caracteres."
          ),
          rangelength: jQuery.validator.format(
            "Por favor, escribe un valor entre {0} y {1} caracteres."
          ),
          range: jQuery.validator.format(
            "Por favor, escribe un valor entre {0} y {1}."
          ),
          max: jQuery.validator.format(
            "Por favor, escribe un valor menor o igual a {0}."
          ),
          min: jQuery.validator.format(
            "Por favor, escribe un valor mayor o igual a {0}."
          ),
        });
      }
      if (_.languageCode == "fr") {
        /*
         * Translated default messages for the jQuery validation plugin.
         * Locale: FR
         */
        jQuery.extend(jQuery.validator.messages, {
          required: "Ce champ est requis.",
          remote: "Veuillez remplir ce champ pour continuer.",
          email: "Veuillez entrer une adresse email valide.",
          url: "Veuillez entrer une URL valide.",
          date: "Veuillez entrer une date valide.",
          dateISO: "Veuillez entrer une date valide (ISO).",
          number: "Veuillez entrer un nombre valide.",
          digits: "Veuillez entrer (seulement) une valeur numérique.",
          creditcard: "Veuillez entrer un numéro de carte de crédit valide.",
          equalTo: "Veuillez entrer une nouvelle fois la même valeur.",
          accept: "Veuillez entrer une valeur avec une extension valide.",
          maxlength: jQuery.validator.format(
            "Veuillez ne pas entrer plus de {0} caractères."
          ),
          minlength: jQuery.validator.format(
            "Veuillez entrer au moins {0} caractères."
          ),
          rangelength: jQuery.validator.format(
            "Veuillez entrer entre {0} et {1} caractères."
          ),
          range: jQuery.validator.format(
            "Veuillez entrer une valeur entre {0} et {1}."
          ),
          max: jQuery.validator.format(
            "Veuillez entrer une valeur inférieure ou égale à {0}."
          ),
          min: jQuery.validator.format(
            "Veuillez entrer une valeur supérieure ou égale à {0}."
          ),
        });
      }
    });
    root.find(".required").each(function () {
      const $el = $(this);
      var prev;
      var label = $el.attr("label");
      if (label) prev = coronis.find($el, label);
      else prev = $el.prev();
      if (prev.find("i.required").length == 0)
        prev.append(
          '&nbsp;<i class="required nonimportant">(' + _("Required") + ")</i>"
        );
    });
  }
};

d.fix = function (root) {
  if (!root) root = $("body");
  d.fixDateInputs(root);
  // d.fixAutocomplete(root);
  d.fixRequired(root);
  d.fixTimeInputs(root);
};

fix_register(d.fix);

// export the fix function
export function fix(root) {
  d.fix(root);
}

jsfix.register("js-checked-show", function ($el, sel) {
  var check_if_show = function () {
    if ($el.prop("checked")) {
      coronis.find($el, sel).show();
    } else coronis.find($el, sel).hide();
  };

  // Not on $el, as this notifies only when it gets active, must check all other mates
  if ($el.attr("type") == "radio") {
    // Tell others in group they are no longer.
    $("[name=" + $el.attr("name") + "]").change(check_if_show);
  } else {
    $el.change(check_if_show);
  }
  check_if_show();
});
jsfix.register("js-select-val", function ($el, val) {
  if (!$el.val()) $el.val(val);
});
jsfix.register("js-select", function ($el, val) {
  $el.val(val);
});
jsfix.register("js-load-on-select", function ($el, sel) {
  $el.change(function () {
    var url = $el.find(":selected").attr("url");
    if (url) var area = coronis.find($el, sel);
    area.load(url, function () {
      coronis.fix(area);
    });
  });
});

jsfix.register("js-show-when-selected", function ($el, val) {
  var options = $(val);
  var show_options = $.makeArray(
    options.map(function () {
      return $(this).val();
    })
  );

  var parent = options.parent();
  var check_if_show = function () {
    console.log("test");
    if (show_options.indexOf(parent.val()) >= 0) $el.show();
    else $el.hide();
  };
  check_if_show();
  parent.change(check_if_show);
});
/**
 * @name js-submit-reload
 * @short When this form (or form child) is posted, the $el itself is replaced with the response to this post.
 *
 * It is usefull to for exmaple use non-ajax forms that automatically become ajax forms.
 *
 * @param toreplace If any, the element to replace on submit. If not, the same el.
 */
jsfix.register("js-submit-reload", function ($el) {
  var $toreplace = $el;
  if ($el.attr("js-submit-reload"))
    $toreplace = $($el.attr("js-submit-reload"));
  $.merge($el.filter("form"), $el.find("form")).submit(function (ev) {
    ev.preventDefault();
    var $form = $(this);
    var submit;
    if ($form.attr("method") == "POST") submit = $.post;
    else submit = $.get;

    submit(
      $form.attr("action"),
      $form.serialize() + "&format=ajax",
      function (data) {
        var $nel = $(data);
        $toreplace.replaceWith($nel);
        d.fix($nel);
        import_by_name("coronis").then(function (coronis) {
          coronis.fix($nel);
        });
      },
      "html"
    );
  });
});

/**
 * @short Submits the form, and uses the json response to fill another form
 *
 * For example to use a select to allow autocomplete of another form.
 *
 * @param js-submit-json-fill A selector to the form to fill.
 *
 * Each key for the returned dict is the name of the input to fill.
 *
 * Can also fill arrays for select options, with each element a dict of {val:..., text:...}
 */
jsfix.register("js-submit-json-fill", function ($el, sel) {
  var $form = $(sel);
  $el.submit(function (ev) {
    ev.preventDefault();
    var submit;
    if ($el.attr("method") == "POST") submit = $.post;
    else submit = $.get;

    var fill = function ($form, data) {
      if (data instanceof Array) {
        // This is for selects
        $form.html("");
        data.forEach(function () {
          const v = this;
          $form.append($("<option>").val(v.val).text(v.text));
        });
      } else {
        // Other objects.
        var k;
        for (k in data) {
          $form.find("[name=" + k + "]").val(data[k]);
        }
      }
    };

    submit(
      $el.attr("action"),
      $el.serialize() + "&format=json",
      function (data) {
        fill($form, data);
      },
      "json"
    );
  });
});

/**
 * @name js-toggle-show
 * @short Toggles the selected element, on click of this element
 */
jsfix.register("js-toggle-show", function ($el, totoggle) {
  var update = function () {
    var $toto = coronis.find($el, totoggle);
    if (
      $el.filter("input:checked").length ||
      $el.find("input:checked").length
    ) {
      //console.log("show %o %o", $el[0].id, $toto[0])
      $toto.show();
    } else {
      //console.log("hide %o %o", $el[0].id, $toto[0])
      $toto.hide();
    }
  };
  $el.change(update);
  update();
});
/**
 * @name js-copy-on-change
 */
jsfix.register("js-copy-on-change", function ($el, data) {
  $el.change(function () {
    $(data).val($el.val()).change();
  });
});

/**
 * @name js-submit-async
 * @short Submits a form asynchronously, and writes a success or failure tag above the submit button.
 *
 * On both cases the content of the result is shown, but class changes from success to failure.
 */
jsfix.register("js-submit-async", function ($el, data) {
  $el.submit(function (ev) {
    ev.preventDefault();

    if (
      $el
        .find(".required.error")
        .not("[js-required-if-visible]:hidden .required.error").length > 0
    ) {
      var msg = $('<div class="failure">').text(
        _("There are errors on the form. Check and try again.")
      );
      msg
        .delay(3000)
        .fadeOut()
        .queue(function () {
          msg.remove();
        });
      $el.find("[type=submit]").before(msg);
      return;
    }

    var submit = function (url, form, cb) {
      var formData = new FormData(form[0]);
      console.log(formData);
      var aj = $.ajax({
        url: url,
        type: "POST",
        data: formData,
        success: cb,
        contentType: false,
        processData: false,
      });
      return aj;
    };
    var sending = $('<div class="success">').text(_("Sending"));
    $el.find("[type=submit]").before(sending);
    submit($el.attr("action"), $el, function (data) {
      if (data.slice(0, 9) == "redirect:") {
        window.location = data.slice(9);
        return;
      }
      sending.remove();
      var msg = $('<div class="success">').html(data);
      msg
        .delay(3000)
        .fadeOut()
        .queue(function () {
          msg.remove();
        });
      $el.find("[type=submit]").before(msg);
    }).error(function (ev) {
      sending.remove();
      var data = ev.responseText;
      var msg = $('<div class="failure">').text(data);
      msg
        .delay(3000)
        .fadeOut()
        .queue(function () {
          msg.remove();
        });
      $el.find("[type=submit]").before(msg);
    });
  });
});

/**
 * @short Loads the image from the form, and set it into a img
 */
jsfix.register("js-file-to-img", function ($el, sel) {
  $el.on("change", function (ev) {
    var fr = new FileReader();
    fr.onload = function () {
      $(sel).attr("src", fr.result);
    };
    fr.readAsDataURL($el[0].files[0]);
  });
});

jsfix.register("js-dup-and-clear-on-click", function ($el, sel) {
  $el.click(function () {
    var $cl = coronis.find($el, sel);
    var nel = $cl.clone();
    nel.removeClass("template");
    $cl.parent().append(nel);
    nel.find("input").val("");
    nel.find(".hasDatepicker").removeClass("hasDatepicker").removeAttr("id");
    coronis.fix(nel);
  });
});

/**
 * @short Show an element only when this element is selected. When unselected, hide.
 */
jsfix.register("js-selected-show", function ($el, sel) {
  var toshow = coronis.find($el, sel);
  var select = $($el.parent());
  var option = $el.val();
  var update = function () {
    if (select.val() == option) toshow.show();
    else toshow.hide();
  };
  select.change(update);
  update();
});

/**
 * @short For checkboxes that share a checkbox group, only one can be selected.
 *
 * The group mark is an element, normally a common parent, but not necesarily.
 */
jsfix.register("js-checkbox-group", function ($el, sel) {
  // Add the element to the group.
  var $p = coronis.find($el, sel);
  var gr = $p.data("js-checkbox-group") || [];
  gr.push($el);
  $p.data("js-checkbox-group", gr);

  // When clicked, turn them all off, me on.
  $el.click(function () {
    $($p.data("js-checkbox-group")).each(function () {
      const $el = $(this);
      $el.prop("checked", false).change();
    });
    $el.prop("checked", true).change();
  });
});

/**
 * @short Shows a message before leaving the page if any input has changed on the $el.
 *
 * If reset_sel selected element is clicked, the change flag is reset, so it can exit page normally.
 */
jsfix.register("js-confirm-exit-after-edit", function ($el, reset_sel) {
  var changed = false;
  var modified = function () {
    changed = true;
  };
  var reset = function () {
    changed = false;
  };
  $el.find("input, select, textarea").on("keyup", modified);
  $(reset_sel).click(reset);

  $(window).on("beforeunload", (ev) => {
    if (changed) {
      return _(
        "There are unsaved changes. Are you sure you want to leve this page?"
      );
    }
  });
});

/**
 * @short Hide the children of sel that do not comply with filter=$el.val()
 *
 */
jsfix.register("js-select-filter", function ($el, sel) {
  var $tohide;
  var $sel;

  if (sel.indexOf("|") >= 0) {
    var tohide = sel.split("|")[0];
    $sel = coronis.find($el, tohide);
    sel = sel.split("|")[1];
    $tohide = coronis.find($el, sel);
  } else {
    $sel = coronis.find($el, sel);
    $tohide = $sel;
  }

  var $maybehide = $sel.find("[filter]");
  var update = function () {
    $tohide.show();
    var val = $el.val();
    var oval = $maybehide.parent().val() || $maybehide.parent().attr("jvalue"); // Other value, for optional selector.

    // Hide everything, then show whats visible.
    $maybehide.hide();
    var $shown = $maybehide.filter('[filter="' + val + '"]').show();
    if ($shown.length == 0) $tohide.hide();

    // If previous selected, or default is visible, select it, else select none
    if ($shown.filter("[value=" + oval + "]").length != 0)
      $maybehide.parent().val(oval);
    else $maybehide.parent().val("");
    $maybehide.parent().change();
  };
  update();
  $el.change(update);
});

/**
 * @short When slected whis radio, set the value into the givel selector
 */
jsfix.register("js-radio-for", function ($el, sel) {
  var $for = coronis.find($el, sel);
  $el.click(function () {
    $for.val($el.val());
  });
  $for.change(function () {
    if ($for.val() == $el.val()) $el.prop("checked", true).change();
  });
});

jsfix.register("js-search", function ($el, lis) {
  var contains = function (li, txt) {
    var tt = txt.split(" ");
    var i;
    for (i = 0; i < tt.length; i++) {
      if (!tt[i]) continue;
      if (li.text().toLowerCase().indexOf(tt[i]) <= 0) return false;
    }
    return true;
  };

  var search = function () {
    var txt = $el.val().toLowerCase();
    var $lis = $(lis);

    $lis.each(function () {
      const $el = $(this);
      if (contains($el, txt)) $el.show();
      else $el.hide();
    });
    if ($lis.find(".selected:visible").length == 0) {
      $($lis.find("a:visible:first")[0]).click();
    }
  };

  $el.change(search);
  $el.parent().find(".js-search").click(search);
});

jsfix.register("js-checkbox-selects", function ($el, sel) {
  var $sel = coronis.find($el, sel);
  var update = function () {
    console.log($el.prop("checked"));
    if ($el.prop("checked")) $sel.addClass("selected");
    else $sel.removeClass("selected");
  };
  $el.change(update);
  update();
});

jsfix.register("js-confirm-before-submit", function ($form, text) {
  $form.submit(function (ev) {
    if (!confirm(text)) ev.preventDefault();
  });
});

export default d;
